import React, { useState } from 'react'
import { Helmet } from 'react-helmet'
import { HelmetProvider } from 'react-helmet-async'
import Header from './Header'
import FooterSimple from './FooterSimple'
import ElieImage from '../Images/Contact/elie_image.jpeg'
import { Mail, Calendar, Linkedin } from 'lucide-react'

const PUBLIC_URL = process.env.PUBLIC_URL || ''
const IMAGE_LUMINA = `${PUBLIC_URL}/luminaproductview.png`

function Contact() {
  const helmetContext = {}
  const [modalOpen, setModalOpen] = useState(false)
  const [modalTitle, setModalTitle] = useState('')
  const [modalImage, setModalImage] = useState(null)
  const [modalLink, setModalLink] = useState(null)

  const openModal = (title, image, link = null) => {
    setModalTitle(title)
    setModalImage(image)
    setModalLink(link)
    setModalOpen(true)
  }

  const closeModal = () => {
    setModalOpen(false)
    setModalTitle('')
    setModalImage(null)
    setModalLink(null)
  }
  
  return (
    <HelmetProvider context={helmetContext}>
      <Helmet>
        <title>Redi Platforms</title>
        <meta
          name="description"
          content="Redi Platforms leadership and products."
        />
        <meta property="og:image" content="%PUBLIC_URL%/favicon-32x32.png" />
      </Helmet>
      
      <div>
        {/* Header with Logo and Navigation */}
        <Header />

        {/* Leadership section */}
        <div className="container" style={{ paddingTop: '30px' }}>
          <div className="row mb-4">
            <div className="col-12">
              <div className="team-card team-card-horizontal">
                <div className="team-horizontal-layout">
                  <img
                    src={ElieImage}
                    alt="Elie Nabushosi"
                    className="team-avatar"
                  />
                  <div className="team-text-block">
                    <h3 className="team-name">Elie Nabushosi</h3>
                    <p className="team-title">Founder & CEO, Redi Platforms</p>
                    <p className="team-location">San Francisco &amp; New York</p>
                    <div className="team-actions team-actions-left">
                      <a
                        href="mailto:elie@maderedi.com"
                        className="team-icon-button"
                        aria-label="Email Elie"
                      >
                        <Mail size={22} />
                      </a>
                      <a
                        href="https://calendar.app.google/WqJ84iLo29sjKbuo6"
                        className="team-icon-button"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Schedule time with Elie"
                      >
                        <Calendar size={22} />
                      </a>
                      <a
                        href="https://www.linkedin.com/in/elie-nabushosi-mba-65308910a/"
                        className="team-icon-button"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Elie on LinkedIn"
                      >
                        <Linkedin size={22} />
                      </a>
                    </div>
                    <div className="career-highlights">
                      <span className="career-label">Before Redi Platforms</span>
                      <div className="career-logos">
                        <img
                          src={`${PUBLIC_URL}/Google_2015_logo.svg.png`}
                          alt="Google"
                          className="career-logo"
                        />
                        <img
                          src={`${PUBLIC_URL}/Meta-Logo.png`}
                          alt="Meta"
                          className="career-logo"
                        />
                        <img
                          src={`${PUBLIC_URL}/Accenture.svg.png`}
                          alt="Accenture"
                          className="career-logo"
                        />
                        <img
                          src={`${PUBLIC_URL}/Nerdwallet_Horizontal_Logo.png`}
                          alt="NerdWallet"
                          className="career-logo career-logo-nerdwallet"
                        />
                        <img
                          src={`${PUBLIC_URL}/Browserbase logo.png`}
                          alt="Browserbase"
                          className="career-logo"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Products section */}
        <div className="container" style={{ paddingTop: '10px', paddingBottom: '40px' }}>
          <div className="row mb-3">
            <div className="col-12">
              <h2 className="lilitaoneblack2 mb-3 text-start">Owns and Operates Lumina AI</h2>
            </div>
          </div>

          {/* Lumina - full width */}
          <div className="row mb-3">
            <div className="col-12 d-flex justify-content-center">
              <button
                type="button"
                className="border-0 p-0 bg-transparent w-100"
                onClick={() =>
                  openModal(
                    'Insurance lead management software',
                    IMAGE_LUMINA,
                    'https://luminaisfaster.com'
                  )
                }
              >
                <img
                  className="project-card-image w-100"
                  src={IMAGE_LUMINA}
                  alt="Lumina insurance lead management software"
                  style={{
                    border: '2px solid #e0e0e0',
                    borderRadius: '12px',
                    boxShadow: 'none'
                  }}
                />
              </button>
            </div>
          </div>

        </div>

        <FooterSimple />
      </div>
      {modalOpen && modalImage && (
        <div className="header-modal-backdrop" onClick={closeModal}>
          <div
            className="header-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              className="btn-close header-modal-close"
              aria-label="Close"
              onClick={closeModal}
            />
            {modalTitle && (
              <div className="header-modal-title-row">
                <h5 className="header-modal-title">{modalTitle}</h5>
                {modalLink && (
                  <a
                    href={modalLink}
                    className="header-modal-visit-pill"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Visit site
                  </a>
                )}
              </div>
            )}
            <img
              src={modalImage}
              alt={modalTitle}
              className="header-modal-image"
            />
          </div>
        </div>
      )}
    </HelmetProvider>
  )
}

export default Contact